import {
  DraftHandleValue,
  EditorState,
  Modifier,
  SelectionState,
} from 'draft-js'
import { stateFromHTML } from 'draft-js-import-html'
import { StateAction } from '../types/typeAliases'

export const unselectAllText = (state: EditorState): EditorState => {
  const lastBlock = state.getCurrentContent().getLastBlock()
  const lastBlockKey = lastBlock.getKey()

  return EditorState.forceSelection(
    state,
    new SelectionState({
      anchorKey: lastBlockKey,
      anchorOffset: lastBlock.getLength(),
      focusKey: lastBlockKey,
      focusOffset: lastBlock.getLength(),
    }),
  )
}

export const selectAllText = (state: EditorState): EditorState => {
  const blocks = state.getCurrentContent().getBlockMap()
  const firstBlockKey = blocks.first().getKey()
  const lastBlock = blocks.last()

  return EditorState.forceSelection(
    state,
    new SelectionState({
      anchorKey: firstBlockKey,
      anchorOffset: 0,
      focusKey: lastBlock.getKey(),
      focusOffset: lastBlock.getLength(),
    }),
  )
}

export const backspaceRemovesBullets = (
  command: string,
  state: EditorState,
  set: StateAction<EditorState>,
): DraftHandleValue => {
  if (command === 'backspace') {
    const selection = state.getSelection()
    const contentState = state.getCurrentContent()
    const key = selection.getStartKey()
    const block = contentState.getBlockForKey(key)
    const type = block.getType()
    const firstBlock = contentState.getFirstBlock()

    if (type === 'unordered-list-item' || type === 'ordered-list-item') {
      if (block.getText() === '' && block === firstBlock) {
        let newContentState = Modifier.setBlockType(
          contentState,
          selection,
          'unstyled',
        )
        newContentState = Modifier.replaceText(newContentState, selection, '')

        set(EditorState.push(state, newContentState, 'change-block-type'))
        return 'handled'
      }
    }
  }

  return 'not-handled'
}

export const createState = (value: string): EditorState => {
  const contentState = stateFromHTML(value)
  const newEditorState = EditorState.createWithContent(contentState)
  return newEditorState
}
